import React from "react";
import { Dropdown } from "react-bootstrap";
import { BiDotsVerticalRounded } from "react-icons/bi";
import { ShowForPermission } from "../ShowForPermission";
import { QR_TEMPLATE_EDIT, QR_TEMPLATE_ACTIVATE_DEACTIVATE } from "../../utils/permissionList";

const TemplateMenu = ({
  template,
  toggleTemplateActivity,
  viewTemplate,
  editTemplate,
  openMoveModal,
  templateIsActive
}) => {
  return (
    <Dropdown align="end" onClick={(e) => e.stopPropagation()}>
      <Dropdown.Toggle
        variant="link"
        id={`template-menu-${template?.id}`}
      >
        <span style={{ fontSize: 18, lineHeight: 1.2 }}>⋮</span>
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item
          data-testid="viewTemplateAction"
          onClick={() => viewTemplate && viewTemplate(template)}
        > View
        </Dropdown.Item>
        <ShowForPermission permissions={[QR_TEMPLATE_ACTIVATE_DEACTIVATE]}>
          <Dropdown.Divider />
          <Dropdown.Item
            data-testid="deactivateTemplateAction"
            onClick={() => toggleTemplateActivity(template)}
          > {templateIsActive ? 'Archive' : 'Activate'}
          </Dropdown.Item>
        </ShowForPermission>
        <ShowForPermission permissions={[QR_TEMPLATE_EDIT]}>
          <Dropdown.Divider />
          <Dropdown.Item
            data-testid="editTemplateAction"
            onClick={() => editTemplate && editTemplate(template)}
          >
            Edit
          </Dropdown.Item>
        </ShowForPermission>
        <Dropdown.Divider />
        <Dropdown.Item
          data-testid="moveTemplateAction"
          onClick={() => openMoveModal && openMoveModal(template)}
        >
          Move
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default TemplateMenu;
